<ng-container *ngIf="paymentType === 'pay-with-credit-card'">
    <app-pay-with-credit-card
        [creditCardRequiredParams] = "creditCardRequiredParams"
        (onError) = "onErrorReceive()"
    ></app-pay-with-credit-card>
</ng-container>
<ng-container *ngIf="paymentType === 'pay-with-defined-card' ">
    <app-core-pay-with-defined-card
        [definedCardParams] = "definedCardParams"
        (onError) = "onErrorReceive()"
    ></app-core-pay-with-defined-card>
</ng-container>
<ng-container *ngIf="paymentType === 'etisalat'">
    <app-etisalat
        [etisalatRequiredParams] = "etisalatRequiredParams"
        (onError) = "onErrorReceive()"
    ></app-etisalat>
</ng-container>